import React from "react";

function Calculators() {
	return <h1>Calculators content</h1>;
}

export default Calculators;
